import React from 'react';
import { connect } from 'react-redux';
import ENUMS from '../../../../enums/index';
import ShowForPermission from '../../../../components/ShowForPermission';
import * as reservationsActions from '../../../../redux/reservations/actions';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Spin from '../../../../components/loading';
import { numberWithCommas } from '../../../../utils/formatter';
import { enumHelper, domManipulator } from '../../../../utils';
import AlertAndConfirmation from '../../../../utils/AlertAndConfirmation';

class ReservationDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alertFlag: false
    };
  }



  componentDidUpdate(prevProps) {
    if(this.props.isOpen !== prevProps.isOpen && this.props.isOpen) {
      this.props.fetchReservationDetails(this.props.reservationId);
    }
  }

  renderButtons = (status, reservationId) => {
    switch (status) {
      case ENUMS.CAFE_RESERVATION.values.WAITING: {
        return (
          <ShowForPermission permission={ENUMS.PERMISSIONS.values.EDIT_STATUS_RESERVE}>
            <button
              className={`btn btn-success mx-5`}
              onClick={() => this.updateReservationStatus(reservationId, 'APPROVED')}
            >
              {locales('tables.approveReserve')}
            </button>
            <button
              className={`btn btn-danger mx-5`}
              onClick={() => this.updateReservationStatus(reservationId, 'REJECTED')}
            >
              {locales('tables.rejectReserve')}
            </button>
          </ShowForPermission>
        );
      }

      case ENUMS.CAFE_RESERVATION.values.APPROVED: {
        return (
          <div className="px-5">
            <ShowForPermission permission={ENUMS.PERMISSIONS.values.EDIT_STATUS_RESERVE}>
              <button
                className={`btn btn-danger mx-5`}
                onClick={() => this.updateReservationStatus(reservationId, 'CLIENT_DO_NOT_CAME')}
              >
                {locales('tables.clientDidNotCome')}
              </button>
            </ShowForPermission>

            <ShowForPermission permission={ENUMS.PERMISSIONS.values.EDIT_STATUS_RESERVE}>
              <button
                className={`btn btn-success mx-5`}
                onClick={() => this.updateReservationStatus(reservationId, 'START')}
              >
                {locales('tables.startReservation')}
              </button>
            </ShowForPermission>
          </div>
        );
      }

      case ENUMS.CAFE_RESERVATION.values.AUTO_APPROVED: {
        return (
          <div className="px-5">
            <ShowForPermission permission={ENUMS.PERMISSIONS.values.EDIT_STATUS_RESERVE}>
              <button
                className={`btn btn-danger mx-5`}
                onClick={() => this.updateReservationStatus(reservationId, 'CLIENT_DO_NOT_CAME')}
              >
                {locales('tables.clientDidNotCome')}
              </button>
            </ShowForPermission>

            <ShowForPermission permission={ENUMS.PERMISSIONS.values.EDIT_STATUS_RESERVE}>
              <button
                className={`btn btn-success mx-5`}
                onClick={() => this.updateReservationStatus(reservationId, 'START')}
              >
                {locales('tables.startReservation')}
              </button>
            </ShowForPermission>
          </div>
        );
      }
      default:
        break;
    }
  };

  updateReservationStatus = (reservationId, status) => {
    if (status !== 'START') {
      const params = {id:reservationId}
      this.props.editCafeReservationStatus(params, status).then(() => {
        let {
          editCafeReservationStatusError,
          editCafeReservationStatusFailed,
          editCafeReservationStatusMessage
        } = this.props;
        if (
          editCafeReservationStatusError == false &&
          editCafeReservationStatusMessage == null &&
          editCafeReservationStatusFailed == false
        ) {
          AlertAndConfirmation({
            title: locales('titles.editionsDoneSuccessfully'),
            text: '',
            type: 'success'
          });
          this.props.closeModal();
        }
      });
    } else {
      this.props.startReservation(reservationId, status).then(() => {
        let { startReservationError, startReservationFailed, startReservationMessage } = this.props;
        if (
          startReservationError == false &&
          startReservationFailed == false &&
          startReservationMessage == null
        ) {
          AlertAndConfirmation({
            title: locales('titles.editionsDoneSuccessfully'),
            text: '',
            type: 'success'
          });
          this.setState({ alertFlag: true });
          domManipulator.scrollToTop();
          setTimeout(() => {
            this.props.closeModal();
          }, 4000);
        }
      });
    }
  };

  render() {
    let {
      editCafeReservationStatus,
      reservationId,
      loading,
      error,
      failed,
      message,
      editCafeReservationStatusLoading,
      editCafeReservationStatusFailed,
      editCafeReservationStatusError,
      editCafeReservationStatusMessage,
      reservationDetails,

      startReservationLoading,
      startReservationFailed,
      startReservationError,
      startReservationMessage
    } = this.props;

    let {
      createdFullName,
      persons,
      status,
      createdAt,
      startAt,
      endAt,
      respondedAt,
      trackingNumber,
      baseCost,
      meal,
      reserveType,
      respondedFullName,
      reservedTables
    } = reservationDetails;

    return (
      <Modal id="financial-transaction-modal" size="xl" isOpen={this.props.isOpen}>
        <ModalHeader>
          <div className="row">
            <div className="col-11">{locales('titles.cafeReservationDetails')}</div>
            <div className="col-1 text-left">
              <a
                href="#"
                className=""
                onClick={event => {
                  event.preventDefault();
                  this.props.closeModal();
                }}
              >
                <i className="fas fa-times"></i>
              </a>
            </div>
          </div>
        </ModalHeader>
        <ModalBody>
          <Spin spinning={loading || editCafeReservationStatusLoading || startReservationLoading}>
            <article>
              {error || editCafeReservationStatusError || startReservationError ? (
                <div className="alert alert-danger">{locales('messages.server.error')}</div>
              ) : (
                <>
                  {(failed || editCafeReservationStatusFailed || startReservationFailed) && (
                    <div className="alert alert-danger">
                      {message || editCafeReservationStatusMessage || startReservationMessage}
                    </div>
                  )}
                  {this.state.alertFlag && (
                    <div className="alert alert-success">
                      {locales('titles.reserveStartedAndRedirected')}
                    </div>
                  )}
                  <article className="col-12">
                    <div className="col-12 p-0 py-1 font-weight-bold text-dark">
                      {locales('titles.reserveBasicInfo')}
                    </div>

                    <div className="col-12 d-flex border rounded py-2 px-1 flex-wrap">
                      <div className="col-12 d-flex  px-1 my-2">
                        <div className="col-6 d-flex align-items-center">
                          <div className="col-5 text-muted">{locales('tables.requestor')} : </div>
                          <div className="col-7 text-dark font-weight-bold font-large">
                            {createdFullName}
                          </div>
                        </div>
                        <div className="col-6 d-flex justify-content-end align-items-center p-0">
                          <div className="col-5 text-muted text-left">{locales('fields.createdAt')} : </div>
                          <div className="col-7 text-left text-dark font-weight-bold font-large">
                            {createdAt}
                          </div>
                        </div>
                      </div>
                      <div className="col-12 d-flex  px-1 my-2">
                        <div className="col-6 d-flex align-items-center">
                          <div className="col-5 text-muted">{locales('tables.reserveStartingTime')} : </div>
                          <div className="col-7 text-dark font-weight-bold font-large">{startAt}</div>
                        </div>
                        <div className="col-6 d-flex justify-content-end align-items-center p-0">
                          <div className="col-5 text-muted text-left">
                            {locales('tables.reserveEndingTime')} :{' '}
                          </div>
                          <div className="col-7 text-left text-dark font-weight-bold font-large">
                            {endAt}
                          </div>
                        </div>
                      </div>
                      <div className="col-12 d-flex  px-1 my-2">
                        <div className="col-6 d-flex align-items-center">
                          <div className="col-5 text-muted">{locales('tables.peopleCount')} : </div>
                          <div className="col-7 text-dark font-weight-bold font-large">{persons}</div>
                        </div>
                        <div className="col-6 d-flex justify-content-end align-items-center p-0">
                          <div className="col-5 text-muted text-left">
                            {locales('tables.mealPortions')} :{' '}
                          </div>
                          <div className="col-7 text-left text-dark font-weight-bold font-large">
                            {meal &&
                              meal.length &&
                              enumHelper.convertEnumValueToTitle(ENUMS.MEAL_PORTIONS.list, meal)}
                          </div>
                        </div>
                      </div>
                      <div className="col-12 d-flex  px-1 my-2">
                        <div className="col-6 d-flex align-items-center">
                          <div className="col-5 text-muted">{locales('messages.tables')} : </div>
                          <div className="col-7 text-dark font-weight-bold font-large">
                            {reservedTables &&
                              reservedTables.length &&
                              reservedTables.map(
                                (ele, index, self) => ` ${ele.num} ${index < self.length - 1 ? '،' : ''}`
                              )}
                          </div>
                        </div>
                        <div className="col-6 d-flex justify-content-end align-items-center p-0">
                          <div className="col-5 text-muted text-left">
                            {locales('tables.reservationType')} :{' '}
                          </div>
                          <div className="col-7 text-left text-dark font-weight-bold font-large">
                            {reserveType &&
                              reserveType.length &&
                              enumHelper.convertEnumValueToTitle(ENUMS.RESERVATION_TYPES.list, reserveType)}
                          </div>
                        </div>
                      </div>
                      <div className="col-12 d-flex  px-1 my-2">
                        <div className="col-6 d-flex align-items-center">
                          <div className="col-5 text-muted">{locales('tables.respondedAt')} : </div>
                          <div className="col-7 text-dark font-weight-bold font-large">{respondedAt}</div>
                        </div>
                        <div className="col-6 d-flex justify-content-end align-items-center p-0">
                          <div className="col-5 text-muted text-left">
                            {locales('tables.respondedFullName')} :{' '}
                          </div>
                          <div className="col-7 text-left text-dark font-weight-bold font-large">
                            {respondedFullName}
                          </div>
                        </div>
                      </div>
                      <div className="col-12 d-flex my-2">
                        <div className="col-2 text-muted">{locales('tables.status')} : </div>
                        <div className="col-2 text-center text-dark font-weight-bold font-large p-0 m-0">
                          {status &&
                            status.length &&
                            enumHelper.convertEnumValueToTitle(ENUMS.CAFE_RESERVATION.list, status)}
                        </div>
                      </div>
                    </div>
                    <div className="my-4">
                      <div className="col-12 p-0 py-1 font-weight-bold text-dark">
                        {locales('titles.tablesInfo')}
                      </div>
                      <div className={`border border-1 rounded`}>
                        {reservedTables &&
                          reservedTables.length &&
                          reservedTables.map((table, index, self) => (
                            <div
                              key={index}
                              className={`col-12 ${index < self.length ? 'border-bottom' : ''}`}
                            >
                              <div className="col-12 d-flex  px-1 my-2">
                                <div className="col-6 d-flex align-items-center">
                                  <div className="col-5 text-muted">{locales('tables.tableNumber')} : </div>
                                  <div className="col-7 text-dark font-weight-bold font-large">
                                    {table.num}
                                  </div>
                                </div>
                              </div>
                              <div className="col-12 d-flex  px-1 my-2">
                                <div className="col-6 d-flex justify-content-end align-items-center p-0">
                                  <div className="col-5 text-muted">{locales('tables.startTime')} : </div>
                                  <div className="col-7 text-dark font-weight-bold font-large">
                                    {table.hours.fromTime}
                                  </div>
                                </div>
                                <div className="col-6 d-flex justify-content-end align-items-center p-0">
                                  <div className="col-5 text-muted text-left">
                                    {locales('tables.endTime')} :{' '}
                                  </div>
                                  <div className="col-7 text-left text-dark font-weight-bold font-large">
                                    {table.hours.toTime}
                                  </div>
                                </div>
                              </div>
                              <div className="col-12 d-flex  px-1 my-2">
                                <div className="col-6 d-flex align-items-center">
                                  <div className="col-5 text-muted">{locales('tables.peopleCount')} : </div>
                                  <div className="col-7 text-dark font-weight-bold font-large">
                                    {table.totalChairs}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                    <div className="col-12 p-0 py-1 font-weight-bold text-dark">
                      {locales('fields.payment.status')}
                    </div>
                    <div className="col-12 d-flex py-2 px-1 flex-wrap border rounded">
                      <div className="col-12 d-flex  px-1 my-2">
                        <div className="col-6 d-flex align-items-center">
                          <div className="col-5 text-muted">{locales('tables.baseCost')} : </div>
                          <div className="col-7 text-dark font-weight-bold font-large">
                            {numberWithCommas(baseCost)}
                          </div>
                        </div>
                        <div className="col-6 d-flex align-items-center">
                          <div className="col-5 text-muted">{locales('fields.trackingNumber')} : </div>
                          <div className="col-7 text-dark font-weight-bold font-large direction-ltr">
                            {trackingNumber}
                          </div>
                        </div>
                      </div>
                    </div>
                  </article>
                </>
              )}
            </article>
          </Spin>
        </ModalBody>
        <ModalFooter>
          <div className="d-flex col-12 justify-content-end align-items-center">
            {this.renderButtons(status, reservationId)}
            <button className="btn btn-default mx-1" onClick={() => this.props.closeModal()}>
              {locales('labels.cancel')}
            </button>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    reservationDetails: state.reservationsReducer.cafeReservationDetails,
    loading: state.reservationsReducer.cafeReservationDetailsLoading,
    message: state.reservationsReducer.cafeReservationDetailsMessage,
    failed: state.reservationsReducer.cafeReservationDetailsFailed,
    error: state.reservationsReducer.cafeReservationDetailsError,

    editCafeReservationStatusLoading: state.reservationsReducer.editCafeReservationStatusLoading,
    editCafeReservationStatusFailed: state.reservationsReducer.editCafeReservationStatusFailed,
    editCafeReservationStatusError: state.reservationsReducer.editCafeReservationStatusError,
    editCafeReservationStatusMessage: state.reservationsReducer.editCafeReservationStatusMessage,

    startReservationLoading: state.reservationsReducer.startReservationLoading,
    startReservationFailed: state.reservationsReducer.startReservationFailed,
    startReservationError: state.reservationsReducer.startReservationError,
    startReservationMessage: state.reservationsReducer.startReservationMessage
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchReservationDetails: id => dispatch(reservationsActions.fetchReservationDetails(id)),
    startReservation: id => dispatch(reservationsActions.startReservation(id)),
    editCafeReservationStatus: (params, status) => dispatch(reservationsActions.editReserveStatus(params, status))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReservationDetails);
